module.exports = __webpack_public_path__ + "media/icons/caret-down-white-1b9fa6d4.svg";